import { classNames } from "@/react/helpers/twMergeWithCN";
import { NavLink, useLocation, useRouteMatch } from "react-router-dom";
import { useGetSidebarLinkClass } from "@circle-react/components/Spaces/SidebarV2/CommunityMenu/SpaceList/useGetSidebarLinkClass";
import { communitiesPaths } from "@circle-react/helpers/routerPathHelpers";
import type { IconType } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";

export interface PlatformMenuItemLinkV3Props {
  className?: string;
  icon: IconType;
  isActive?: boolean;
  isDisabled?: boolean;
  linkTo: string;
  onClose?: () => void;
  text: string;
}

interface LocationState {
  prevLocation?: Location;
}

export const PlatformMenuItemLinkV3 = ({
  text,
  linkTo,
  icon,
  isActive: isActiveProp = false,
  isDisabled = false,
  onClose,
  className,
}: PlatformMenuItemLinkV3Props) => {
  const { getActiveInactiveClasses } = useGetSidebarLinkClass();
  const location = useLocation<LocationState | undefined>();
  const match = useRouteMatch({ path: linkTo, exact: true });

  const { state } = location;
  const { prevLocation } = state ?? {};
  const isInvokedFromPostModalAndFromFeed =
    !!prevLocation && !prevLocation.pathname.startsWith("/c");
  const isFeedPlatformItem = linkTo.includes(communitiesPaths.feed());
  const isActive = Boolean(match);

  const activeInactiveClasses = getActiveInactiveClasses(
    isActive || isActiveProp,
    isInvokedFromPostModalAndFromFeed,
    isFeedPlatformItem,
  );

  return (
    <>
      <NavLink
        to={linkTo}
        title={text}
        className={classNames(
          "h-8.5 flex w-full items-center gap-2 !rounded-lg px-4 py-1.5 transition-colors duration-200",
          activeInactiveClasses,
          className,
        )}
        onClick={event => {
          if (isDisabled) {
            event.preventDefault();
          }
        }}
        aria-disabled={isDisabled}
      >
        <Icon type={icon} size={20} />
        <h4 className="text-xs-plus max-w-full truncate font-medium text-current">
          {text}
        </h4>
      </NavLink>
      {onClose && (
        <button
          className={classNames(
            "focus-visible:outline-secondary absolute right-2 top-1/2 flex size-5 -translate-y-1/2 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
            activeInactiveClasses,
          )}
          type="button"
          onClick={onClose}
        >
          <Icon type="16-close" size={16} />
        </button>
      )}
    </>
  );
};
